import { Component } from 'react';
import Url from 'urlinator/Url';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { withRouter } from 'react-router-dom';
import { parse as parseQuery } from 'hub-http/helpers/params';
import { FireAlarm } from 'foundations-components/transitional/components/FireAlarm';
import { jsx as _jsx } from "react/jsx-runtime";
class EnvironmentMismatch extends Component {
  constructor(props, context) {
    super(props, context);
    this.getCorrectedUrl = (currentUrl, loginRedirectUrl) => {
      currentUrl = currentUrl.clone();
      currentUrl.production = true;
      if (loginRedirectUrl) {
        loginRedirectUrl = loginRedirectUrl.clone();
        currentUrl.removeParam('loginRedirectUrl');
        loginRedirectUrl.production = true;
        currentUrl.pushParam('loginRedirectUrl', loginRedirectUrl.href);
      }
      return currentUrl.href;
    };
    const _currentUrl = new Url(window.location);
    const {
      search
    } = props.location;
    const query = parseQuery(search.substr(1));
    const {
      loginRedirectUrl: loginRedirectUrlQuery
    } = query;
    const _loginRedirectUrl = loginRedirectUrlQuery ? new Url(loginRedirectUrlQuery) : undefined;
    const envMismatch = _loginRedirectUrl && _loginRedirectUrl.production !== undefined && _loginRedirectUrl.production !== _currentUrl.production;
    this.state = {
      correctedUrl: this.getCorrectedUrl(_currentUrl, _loginRedirectUrl),
      envMismatch
    };
  }
  render() {
    const {
      correctedUrl,
      envMismatch
    } = this.state;
    const i18nKey = 'login.errors.MISMATCH';
    if (envMismatch) {
      return /*#__PURE__*/_jsx(FireAlarm, {
        type: "warning",
        titleText: I18n.text(`${i18nKey}.title`),
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${i18nKey}.body`,
          options: {
            correctedUrl
          }
        })
      });
    } else {
      return /*#__PURE__*/_jsx("div", {});
    }
  }
}

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof EnvironmentMismatch' is n... Remove this comment to see the full error message
export default withRouter(EnvironmentMismatch);